import { render, staticRenderFns } from "./foodunit.vue?vue&type=template&id=3b1bba31"
import script from "./foodunit.vue?vue&type=script&lang=js"
export * from "./foodunit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports